"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=stringkeys.interface.js.map